import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Row,
} from "reactstrap";

// Context
import { useAuth } from "../../../context/auth";

// Services
import { InputTELEFONE } from "../../../services/mask";
import { InputCNPJ } from "../../../services/mask";
import { showMessage } from "../../../services/message";

//API
import { api_PUT } from "../../../services/api_service";
import { api_POST } from "../../../services/api_service";

//Helpers
import { isValidCNPJ } from "../../../helpers/valid";

export default function GeradorObra({
  item,
  opcao,
  handleProximoStep,
  handleStepAnterior,
}) {
  const { session, setLoading } = useAuth();
  const [registro, setRegistro] = useState(null);
  const [permiteEditar, set_permiteEditar] = useState(true);

  const { register, handleSubmit, setValue, errors } = useForm({
    mode: "onBlur",
  });

  useEffect(() => {
    if (
      session != null &&
      session.tipoAcesso === "AreaRestrita" &&
      item != null
    )
      set_permiteEditar(true);

    if (item) {
      setRegistro(item);
      const obraData = getObraData();
      if (obraData) setAllValues(obraData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  const getObraData = () => {
    const isRequerimento = opcao.tipoCadastro === "Requerimento";
    const obraList = isRequerimento
      ? item?.requerimentoGerador?.[0]?.requerimentoGeradorObras
      : item?.protocoloGerador?.[0]?.protocoloGeradorObras;

    return obraList?.length ? obraList[0] : null;
  };

  const setAllValues = (obra) => {
    const fields = [
      "razaoSocial",
      "fantasia",
      "cnpj",
      "telefone",
      "email",
      "contato",
    ];
    fields.forEach((field) => {
      if (obra[field]) setValue(field, obra[field], { shouldValidate: true });
    });
  };

  function handleCriarObjetoTipoRequerimento(data) {
    const obra =
      registro?.requerimentoGerador?.[0]?.requerimentoGeradorObras?.[0];
    const requerimentoGeradorId =
      registro?.requerimentoGerador?.[0]?.requerimentoGerador_Id;

    return {
      ...obra,
      requerimentoGeradoresObra_Id: obra?.requerimentoGeradoresObra_Id ?? 0,
      requerimentoGerador_Id:
        obra?.requerimentoGerador_Id ?? requerimentoGeradorId,
      empreendimento: obra?.empreendimento ?? "",
      razaoSocial: data.razaoSocial,
      fantasia: data.fantasia,
      cnpj: data.cnpj.replace(/\D/g, ""),
      telefone: data.telefone,
      email: data.email,
      contato: data.contato,
    };
  }

  function handleCriarObjetoTipoProtocolo(data) {
    const obra = registro?.protocoloGerador?.[0]?.protocoloGeradorObras?.[0];
    const protocoloGeradorId =
      registro?.protocoloGerador?.[0]?.protocoloGerador_Id;
    return {
      ...obra,
      protocoloGeradoresObra_Id: obra?.protocoloGeradoresObra_Id ?? 0,
      protocoloGerador_Id: obra?.protocoloGerador_Id ?? protocoloGeradorId,
      empreendimento: obra?.empreendimento ?? "",
      razaoSocial: data.razaoSocial,
      fantasia: data.fantasia,
      cnpj: data.cnpj.replace(/\D/g, ""),
      telefone: data.telefone,
      email: data.email,
      contato: data.contato,
    };
  }

  const onSubmit = async (data) => {
    const isRequerimento = opcao.tipoCadastro === "Requerimento";

    const _cnpj = data.cnpj.replace(/\D/g, "");
    if (_cnpj < 14 || (_cnpj.length === 14 && !isValidCNPJ(_cnpj)))
      return showMessage(
        "Aviso",
        "CNPJ inválido no campo CNPJ/CPF.",
        "warning",
        null
      );

    if (isRequerimento) {
      setLoading(true);
      try {
        const objRequerimento = handleCriarObjetoTipoRequerimento(data);

        let resposta;
        if (!!objRequerimento.requerimentoGeradoresObra_Id) {
          resposta = await api_PUT(
            "RequerimentoGerador/PutRequerimentoGeradorObra/inicial",
            objRequerimento
          );
        } else {
          resposta = await api_POST(
            "RequerimentoGerador/PostRequerimentoGeradorObra",
            objRequerimento
          );
        }

        const novaObra = resposta?.data;
        const registroAtualizado = { ...registro };

        if (registroAtualizado.requerimentoGerador?.[0]) {
          registroAtualizado.requerimentoGerador[0].requerimentoGeradorObras = [
            novaObra,
          ];
        }

        handleProximoStep(registroAtualizado);
      } catch (error) {
        showMessage(
          "Error",
          error?.menssage ?? "Operação com error",
          "error",
          null
        );
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      try {
        const objProtocolo = handleCriarObjetoTipoProtocolo(data);

        let resposta;
        if (!!objProtocolo.protocoloGeradoresObra_Id) {
          resposta = await api_PUT(
            "ProtocoloGerador/PutProtocoloGeradorObra/inicial",
            objProtocolo
          );
        } else {
          resposta = await api_POST(
            "ProtocoloGerador/PostProtocoloGeradorObra",
            objProtocolo
          );
        }

        const novaObra = resposta?.data;
        const registroAtualizado = { ...registro };

        if (registroAtualizado.protocoloGerador?.[0]) {
          registroAtualizado.protocoloGerador[0].protocoloGeradorObras = [
            novaObra,
          ];
        }

        handleProximoStep(registroAtualizado);
      } catch (error) {
        showMessage(
          "Error",
          error?.menssage ?? "Operação com error",
          "error",
          null
        );
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Card className="card-stats">
      <CardBody>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Container style={{ maxWidth: "1000px", margin: "0 auto" }}>
            <h2 className="titulo-solicitacao">Gerador da Obra</h2>
            <Row>
              <Col md="12">
                <Row>
                  {/* Razão Social */}
                  <Col lg={6}>
                    <FormGroup>
                      <label>
                        <b>
                          <span className="text-danger">*</span> Razão Social
                        </b>
                      </label>
                      <Input
                        type="text"
                        name={"razaoSocial"}
                        innerRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                        maxLength="100"
                        readonly={permiteEditar ? false : "readonly"}
                        autoComplete="off"
                      />
                      {errors.razaoSocial && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Nome Fantasia */}
                  <Col lg={6}>
                    <FormGroup>
                      <label>
                        <b>
                          <span className="text-danger">*</span> Nome Fantasia
                        </b>
                      </label>
                      <Input
                        type="text"
                        name={"fantasia"}
                        innerRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                        readonly={permiteEditar ? false : "readonly"}
                        maxLength="100"
                        autoComplete="off"
                      />
                      {errors.fantasia && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* CNPJ */}
                  <Col lg={3}>
                    <FormGroup>
                      <label>
                        <b>
                          <span className="text-danger">*</span> CNPJ
                        </b>
                      </label>
                      <InputCNPJ
                        name="cnpj"
                        defaultValue={
                          item
                            ? opcao.tipoCadastro === "Requerimento"
                              ? item?.requerimentoGerador?.[0]
                                  ?.requerimentoGeradorObras?.[0]?.cnpj || ""
                              : item?.protocoloGerador?.[0]
                                  ?.protocoloGeradorObras?.[0]?.cnpj || ""
                            : ""
                        }
                        inputRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                        readonly={permiteEditar ? false : "readonly"}
                        autoComplete="off"
                      />
                      {errors.cnpj && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Telefone */}
                  <Col lg={3}>
                    <FormGroup>
                      <label>
                        <b>
                          <span className="text-danger">*</span> Telefone
                        </b>
                      </label>
                      <InputTELEFONE
                        type="text"
                        name="telefone"
                        readonly={permiteEditar ? false : "readonly"}
                        defaultValue={
                          item
                            ? opcao.tipoCadastro === "Requerimento"
                              ? item?.requerimentoGerador?.[0]
                                  ?.requerimentoGeradorObras?.[0]?.telefone ||
                                ""
                              : item?.protocoloGerador?.[0]
                                  ?.protocoloGeradorObras?.[0]?.telefone || ""
                            : ""
                        }
                        inputRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                      />
                      {errors.telefone && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Email */}
                  <Col lg={6}>
                    <FormGroup>
                      <label>
                        <b>
                          <span className="text-danger">*</span> Email
                        </b>
                      </label>
                      <Input
                        type="email"
                        name="email"
                        innerRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                          pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: "E-mail inválido",
                          },
                        })}
                        maxLength="50"
                        readonly={permiteEditar ? false : "readonly"}
                        autoComplete="off"
                      />
                      {errors.email && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Contato */}
                  <Col lg={3}>
                    <FormGroup>
                      <label>
                        <b>
                          <span className="text-danger">*</span> Contato
                        </b>
                      </label>
                      <InputTELEFONE
                        type="text"
                        name="contato"
                        readonly={permiteEditar ? false : "readonly"}
                        defaultValue={
                          item
                            ? opcao.tipoCadastro === "Requerimento"
                              ? item?.requerimentoGerador?.[0]
                                  ?.requerimentoGeradorObras?.[0]?.contato || ""
                              : item?.protocoloGerador?.[0]
                                  ?.protocoloGeradorObras?.[0]?.contato || ""
                            : ""
                        }
                        inputRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                      />
                      {errors.contato && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col lg={6} className="text-left">
                <Button
                  color="secondary"
                  onClick={() => handleStepAnterior(registro)}
                  className="btn-mobile"
                >
                  <i className="fas fa-chevron-left" /> Voltar
                </Button>
              </Col>
              <Col lg={6} className="text-right">
                <Button color="success" type="submit" className="btn-mobile">
                  Próxima Etapa <i className="fas fa-chevron-right" />
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      </CardBody>
    </Card>
  );
}
